import { useParams } from "react-router-dom";

import WithdrawContainer from "@/components/shared/withdraw/WithdrawContainer";
import Loader from "@/components/loader/Loader";
import { ErrorState } from "@/components/ErrorState";
import { makeRequest } from "@/utils/makeRequest";
import { useSystemWalletDetails } from "@/hooks";
import { getErrorMessage } from "@/utils/getErrorMessage";
import { toast } from "sonner";
import { useState } from "react";

interface WithdrawPayload {
  assetId: string;
  amount: string;
  destinationAddress: string;
  otp: string;
  securityCode: string;
}

const AdminWithdrawal = () => {
  const { systemType } = useParams();
  const [loading, setLoading] = useState(false);

  const {
    data: wallet,
    isLoading,
    isError,
    refetch,
  } = useSystemWalletDetails(systemType!);

  const withdraw = async (payload: WithdrawPayload) => {
    setLoading(true);

    try {
      await makeRequest.post("/withdrawal", payload);

      toast.success("Withdrawal initiated");

      // if (response) {
      //   navigate("/dashboard/transactions");
      // }

      await refetch();
    } catch (error) {
      toast.error(getErrorMessage(error));

      // Important:
      // rethrow so WithdrawContainer knows
      // that the withdrawal failed.
      throw error;
    } finally {
      setLoading(false);
    }
  };

  if (isLoading) {
    return <Loader type="bounce" />;
  }

  if (isError || !wallet) {
    return (
      <ErrorState
        onRetry={() => {
          refetch();
        }}
      />
    );
  }

  return (
    <WithdrawContainer
      wallet={wallet}
      assets={wallet.assets}
      loading={loading}
      onWithdraw={withdraw}
    />
  );
};

export default AdminWithdrawal;
